/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const FAILED_ANX1_VAL = 'boilderplate/FailedAnx1/FAILED_ANX1_VAL'
export const RESET_FETCH_FAILED = 'boilerplate/FailerInvoice/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/FailedInvoice/ON_NOTIFY'
export const LOADER_STATUS = 'boilerplate/FailerInvoice/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/FailedAnx1/TOTAL_RECORD'
export const ANX1_GET_ITEM = 'boilderplate/FailedAnx1/ANX1_GET_ITEM'
export const ANX1_TOTAL_ITEM_RECORDS = 'boilderplate/FailedAnx1/ANX1_TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'biolderplate/FailedInvoice/TXN_RECORD'
export const RESET_ANX1_VAL = 'boilerplate/FailedAnx1/RESET_ANX1_VAL'